import * as React from "react";
const SvgFiRrTooth = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tooth_svg__a)">
      <path
        fill="#062147"
        d="M15.91 24A2.91 2.91 0 0 1 13 21.091v-6.09a1 1 0 1 0-2 0v6.09a2.91 2.91 0 0 1-5.418 1.476C3.186 18.463 0 12.28 0 6a5.785 5.785 0 0 1 6-6 12.8 12.8 0 0 1 3.915.615A7 7 0 0 0 12 1a7 7 0 0 0 2.085-.385A12.8 12.8 0 0 1 18 0a5.785 5.785 0 0 1 6 6c0 6.278-3.186 12.462-5.582 16.567A2.91 2.91 0 0 1 15.91 24M12 12a3 3 0 0 1 3 3v6.091a.912.912 0 0 0 1.691.47c2.28-3.907 5.31-9.768 5.31-15.56a3.85 3.85 0 0 0-4-4c-1.141-.001-2.275.18-3.359.535A9 9 0 0 1 12 3a9 9 0 0 1-2.642-.464A10.8 10.8 0 0 0 6 2C2.045 2 2 5.837 2 6c0 5.794 3.03 11.655 5.31 15.56A.91.91 0 0 0 9 21.091v-6.09a3 3 0 0 1 3-3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tooth_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTooth;
